const QUESTIONS = [
  {
    id: 'flaveur',
    kicker: 'QUESTION 1 SUR 4',
    question: 'Quel profil de café te correspond le plus ?',
    choices: [
      { value: 'doux',     label: 'Doux et équilibré',  desc: 'Équilibré, doux et sans amertume',                          emoji: '☀️' },
      { value: 'intense',  label: 'Intense et corsé',   desc: 'Des saveurs profondes et prononcées',           emoji: '⚡' },
      { value: 'floral',   label: 'Léger et floral',    desc: 'Aromatique, frais et délicat',  emoji: '🌸' },
      { value: 'gourmand', label: 'Riche et gourmand',  desc: 'Des saveurs sucrées, rondes et réconfortantes',                  emoji: '🍫' }
    ]
  },
  {
    id: 'methode',
    kicker: 'QUESTION 2 SUR 4',
    question: "Quelle méthode d'infusion utilises-tu le plus ?",
    choices: [
      { value: 'espresso',  label: 'Espresso / Machine', desc: 'Espresso, machine automatique ou capsules', emoji: '☕' },
      { value: 'piston',    label: 'Cafetière à piston', desc: 'Aussi appelée French press',               emoji: '🫖' },
      { value: 'filtre',    label: 'Filtre / Drip',      desc: 'V60, Chemex, Mr. Coffee',                  emoji: '💧' },
      { value: 'aeropress', label: 'Un peu de tout',     desc: 'Je varie les plaisirs',                    emoji: '🔄' }
    ]
  },
  {
  id: 'personnalite',
  kicker: 'QUESTION 3 SUR 4',
  question: 'Quelle personnalité te ressemble le plus ?',
  choices: [
    {
      value: 'douce_spontanee',
      label: 'Doux·ce et spontané·e',
      desc: "J’aime les petits plaisirs",
      emoji: '🌷'
    },
    {
      value: 'energique_assumee',
      label: 'Énergique et assumé·e',
      desc: "J’aime quand ça bouge",
      emoji: '⚡'
    },
    {
      value: 'curieuse_creative',
      label: 'Curieux·se et créatif·ve',
      desc: "J’aime découvrir et sortir de ma routine",
      emoji: '✨'
    },
    {
      value: 'aventuriere_libre',
      label: 'Aventurier·ère et libre',
      desc: "J’aime explorer et profiter pleinement de chaque moment",
      emoji: '🌞'
    }
  ]
},

  {
    id: 'lait',
    kicker: 'QUESTION 4 SUR 4',
    question: 'Comment bois-tu généralement ton café ?',
    choices: [
      { value: 'lait',    label: 'Avec du lait',         desc: 'Latte, cappuccino, flat white',      emoji: '🥛' },
      { value: 'noir',    label: 'Noir, sans rien',      desc: "Je préfère goûter le café tel quel", emoji: '🖤' },
      { value: 'vegetal', label: 'Avec du lait végétal', desc: 'Avoine, amande, soja…',             emoji: '🌿' },
      { value: 'decaf',   label: 'Ça dépend du moment',  desc: 'Je change selon mon envie',          emoji: '🔄' }
    ]
  }
];

const HANDLES_QUIZ = [
  'cafe-colombien-1',
  'cafe-kenya',
  'cafe-barista',
  'cafe-barista-glac',
  'cafe-bon-matin',
  'cafe-evasion',
  'cafe-decafeine'
];

const SCORING = {
  'floral':     ['cafe-kenya', 'cafe-colombien-1', 'cafe-evasion'],
  'doux':       ['cafe-bon-matin', 'cafe-colombien-1', 'cafe-barista'],
  'intense':    ['cafe-barista-glac', 'cafe-barista', 'cafe-evasion'],
  'gourmand':   ['cafe-barista', 'cafe-bon-matin', 'cafe-barista-glac'],
  'espresso':   ['cafe-barista-glac', 'cafe-barista', 'cafe-kenya'],
  'piston':     ['cafe-bon-matin', 'cafe-evasion', 'cafe-barista'],
  'filtre':     ['cafe-kenya', 'cafe-colombien-1', 'cafe-evasion'],
  'aeropress':  ['cafe-colombien-1', 'cafe-kenya', 'cafe-evasion'],
  'douce_spontanee':    ['cafe-kenya', 'cafe-decafeine'],
  'energique_assumee':  ['cafe-barista', 'cafe-barista-glac'],
  'curieuse_creative':  ['cafe-colombien-1'],
  'aventuriere_libre':  ['cafe-bon-matin', 'cafe-evasion'],
  'lait':       ['cafe-barista-glac', 'cafe-barista', 'cafe-bon-matin'],
  'noir':       ['cafe-kenya', 'cafe-colombien-1', 'cafe-evasion'],
  'vegetal':    ['cafe-barista-glac', 'cafe-kenya', 'cafe-colombien-1'],
  'decaf':      ['cafe-decafeine', 'cafe-bon-matin', 'cafe-colombien-1'],
};

// ─── État ─────────────────────────────────────────────────────────────────────
let answers = {};
let products = [];

// ─── Init ─────────────────────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', () => {
  const raw = document.getElementById('quiz-products-data');
  if (raw) products = JSON.parse(raw.textContent);
  renderQuestion(0);
});

// ─── Questions ────────────────────────────────────────────────────────────────
function renderQuestion(index) {
  const q = QUESTIONS[index];
  const total = QUESTIONS.length;
  const wrapper = document.getElementById('quiz-questions-wrapper');


  const progressBar = document.getElementById('quiz-progress-bar');
  if (progressBar) progressBar.style.width = ((index / total) * 100) + '%';

  wrapper.innerHTML = `
    <div class="quiz-question">
      <p class="quiz-kicker">${q.kicker}</p>
      <h2 class="quiz-question-title">${q.question}</h2>
      <div class="quiz-choices">
        ${q.choices.map(c => `
          <button class="quiz-choice ${answers[q.id] === c.value ? 'selected' : ''}"
                  data-value="${c.value}"
                  data-question="${q.id}">
            <span class="quiz-choice-emoji">${c.emoji}</span>
            <span class="quiz-choice-label">${c.label}</span>
            <span class="quiz-choice-desc">${c.desc}</span>
          </button>
        `).join('')}
      </div>
      <div class="quiz-nav">
        ${index > 0
  ? `<button class="quiz-btn-back" id="quiz-back">← Retour</button>`
  : '<div class="quiz-nav-placeholder"></div>'
}
        <div class="quiz-dots">
          ${QUESTIONS.map((_, i) => `
            <span class="quiz-dot ${i === index ? 'active' : i < index ? 'done' : ''}"></span>
          `).join('')}
        </div>
        <button class="quiz-btn-next" id="quiz-next" ${!answers[q.id] ? 'disabled' : ''}>
          ${index === total - 1 ? 'Voir mes cafés ☕' : 'Suivant →'}
        </button>
      </div>
    </div>
  `;

  wrapper.querySelectorAll('.quiz-choice').forEach(btn => {
    btn.addEventListener('click', () => {
      answers[btn.dataset.question] = btn.dataset.value;
      renderQuestion(index);
    });
  });

  document.getElementById('quiz-next')?.addEventListener('click', () => {
    if (index < total - 1) renderQuestion(index + 1);
    else showResults();
  });

  document.getElementById('quiz-back')?.addEventListener('click', () => {
    renderQuestion(index - 1);
  });
}

// ─── Scoring ──────────────────────────────────────────────────────────────────
function computeScores() {
  const scores = {};
  products.forEach(p => { scores[p.handle] = 0; });

  Object.values(answers).forEach(answer => {
    (SCORING[answer] || []).forEach((handle, i) => {
      if (scores[handle] !== undefined) scores[handle] += (3 - i);
    });
  });

  return scores;
}

function getTop3() {
  const scores = computeScores();
  return products
    .filter(p => HANDLES_QUIZ.includes(p.handle))
    .sort((a, b) => (scores[b.handle] || 0) - (scores[a.handle] || 0))
    .slice(0, 3)
    .map(p => ({ ...p, rawScore: scores[p.handle] || 0 }));
}

// ─── Résultats ────────────────────────────────────────────────────────────────
function showResults() {
  document.getElementById('quiz-questions-wrapper').classList.add('hidden');

  const progressBar = document.getElementById('quiz-progress-bar');
  if (progressBar) progressBar.style.width = '100%';

  const top3 = getTop3();
  const maxScore = Math.max(...top3.map(p => p.rawScore), 1);

  const resultsEl = document.getElementById('quiz-results-wrapper');
  const cardsEl   = document.getElementById('quiz-results-cards');

  cardsEl.innerHTML = top3.map((p, i) => {
    const pct            = Math.round((p.rawScore / maxScore) * 100);
    const isTop          = i === 0;
    const notes          = (p.notes || '').split(',').map(n => n.trim()).filter(Boolean);
    const variants       = p.variants || [];
    const defaultVariant = variants.find(v => v.title.includes('250')) || variants[0];

    const variantOptions = variants.map(v => `
      <option value="${v.id}"
        ${v.title.includes('250') ? 'selected' : ''}
        ${!v.available ? 'disabled' : ''}>
        ${v.title}${!v.available ? ' — Épuisé' : ''} — ${v.price}
      </option>
    `).join('');

    return `
  <div class="quiz-result-card ${isTop ? 'quiz-result-card--top' : ''}">
    <div class="quiz-result-crown">
      ${isTop ? '⭐ Ton meilleur match' : ''}
    </div>

    <div class="quiz-result-image-wrap">
      <span class="quiz-result-rank">${i + 1}</span>
      <img class="quiz-result-img" src="${p.image}" alt="${p.title}" loading="lazy">
      <span class="quiz-result-badge">${pct}% de correspondance</span>
    </div>

    <div class="quiz-result-info">
      <h3 class="quiz-result-name">${p.title}</h3>
      ${notes.length ? `
        <div class="quiz-result-tags">
          ${notes.map(n => `<span class="quiz-tag">${n}</span>`).join('')}
        </div>` : ''
      }
    </div>

        <div class="quiz-result-purchase">
          ${variants.length > 1 ? `
            <select class="quiz-variant-select" data-card="${i}">
              ${variantOptions}
            </select>
          ` : `<input type="hidden" class="quiz-variant-select" data-card="${i}" value="${defaultVariant?.id}">`}

          <div class="quiz-result-actions">
            <button class="quiz-btn-cart" data-card="${i}" data-variant="${defaultVariant?.id || ''}">
              + Ajouter au panier
            </button>
            <a class="quiz-btn-more" href="${p.url}">Voir les détails →</a>
          </div>
        </div>
      </div>
    `;
  }).join('');

  resultsEl.classList.remove('hidden');

  // ── Sync select → bouton ──
  cardsEl.querySelectorAll('.quiz-variant-select').forEach(select => {
    select.addEventListener('change', () => {
      const btn = cardsEl.querySelector(`.quiz-btn-cart[data-card="${select.dataset.card}"]`);
      if (btn) btn.dataset.variant = select.value;
    });
  });

  // ── Boutons Ajouter au panier ──
  cardsEl.querySelectorAll('.quiz-btn-cart').forEach(btn => {
    btn.addEventListener('click', async () => {
      const variantId = btn.dataset.variant;
      if (!variantId) return;

      btn.disabled = true;
      btn.textContent = 'Ajout en cours…';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: Number(variantId), quantity: 1 })
        });

        if (res.ok) {
          btn.textContent = '✓ Ajouté au panier';
          btn.classList.add('quiz-btn-cart--added');
        } else {
          btn.textContent = 'Erreur — réessaie';
          btn.disabled = false;
        }
      } catch (e) {
        btn.textContent = 'Erreur — réessaie';
        btn.disabled = false;
      }
    });
  });

  // ── Bouton Refaire le quiz ──
  document.getElementById('quiz-restart')?.addEventListener('click', restartQuiz);
}

// ─── Restart ──────────────────────────────────────────────────────────────────
function restartQuiz() {
  answers = {};
  document.getElementById('quiz-results-wrapper').classList.add('hidden');
  document.getElementById('quiz-questions-wrapper').classList.remove('hidden');
  const progressBar = document.getElementById('quiz-progress-bar');
  if (progressBar) progressBar.style.width = '0%';
  renderQuestion(0);
  document.getElementById('quiz-questions-wrapper').scrollIntoView({ behavior: 'smooth', block: 'start' });
}





